module.exports = __webpack_public_path__ + "img/75.b8d10ebf.jpg";